import { useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { toast } from 'sonner'
import { apiService } from '@/services/api'
import { useNavigate } from 'react-router-dom'

interface JoinCampaignDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function JoinCampaignDialog({ open, onOpenChange }: JoinCampaignDialogProps) {
  const [code, setCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleJoin = async () => {
    const trimmedCode = code.trim().toUpperCase()
    
    if (!trimmedCode) {
      toast.error('Por favor, digite o código de acesso')
      return
    }

    if (trimmedCode.length !== 6) {
      toast.error('O código deve ter 6 caracteres')
      return
    }

    setIsLoading(true)
    try {
      const result = await apiService.joinTableByCode(trimmedCode)
      toast.success(result.message)
      setCode('')
      onOpenChange(false)
      // Redirecionar para a campanha
      navigate(`/detalhes/${result.table.id}`)
    } catch (error: any) {
      if (error.status === 404) {
        toast.error('Código inválido ou campanha não encontrada')
      } else if (error.status === 400) {
        toast.error('Você já é membro desta campanha')
      } else {
        toast.error('Erro ao ingressar na campanha')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Ingressar em Campanha</DialogTitle>
          <DialogDescription>
            Digite o código de acesso fornecido pelo professor
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="code">Código de Acesso</Label>
            <Input
              id="code"
              placeholder="ABC123"
              value={code}
              onChange={(e) => {
                // Apenas permitir alfanuméricos, máximo 6 caracteres
                const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6)
                setCode(value)
              }}
              maxLength={6}
              className="text-center text-2xl font-mono tracking-wider"
              autoFocus
            />
            <p className="text-xs text-muted-foreground">
              Digite o código de 6 caracteres fornecido pelo professor
            </p>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleJoin} disabled={isLoading || code.length !== 6}>
            {isLoading ? 'Ingressando...' : 'Ingressar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
